module.exports = __webpack_public_path__ + "static/img/AIRWALLEX_CARD.1144580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sureOrder/AIRWALLEX_CARD.svg
// module id = 7YGJ
// module chunks = 0